import {
  Box,
  Card,
  CardActions,
  CardContent,
  Divider,
  Link,
  makeStyles,
  Typography,
} from '@material-ui/core';
import { ArrowForwardIosRounded } from '@material-ui/icons';
import { App } from 'hydra-data-types';
import { FunctionComponent } from 'react';
import { useHistory } from 'react-router';
import { Analytics } from '../../../helpers/analytics/Analytics';
import { AnalyticsEventName } from '../../../helpers/analytics/AnalyticsEvent';
import { colors } from '../../../theme/colors';

export type ProgramCardProps = {
  appLogo: string;
  description: string;
  creatorInfo: string;
  creatorLogo: string;
  cardColor: string;
  cardActionLabel: string;
  cardActionLink: string;
  externalLink?: boolean;
  isSingleCreator?: boolean;
  app: App;
};

export const ProgramCard: FunctionComponent<ProgramCardProps> = (props) => {
  const {
    appLogo,
    description,
    creatorInfo,
    creatorLogo,
    cardActionLabel,
    cardActionLink,
    externalLink = false,
    isSingleCreator = true,
    app,
  } = props;
  const history = useHistory();
  const classes = useStyles(props);

  function handleOnClick(app: App) {
    Analytics.track({
      event: AnalyticsEventName.a_program_card_clicked,
      program: app,
    });
    externalLink ? window.open(cardActionLink) : history.push(cardActionLink);
  }

  return (
    <Card variant="outlined" className={classes.root} data-testid="program-card">
      <CardContent>
        <Box display="flex" justifyContent="space-between" paddingBottom={1}>
          <Box display="flex" alignItems="flex-end">
            <img src={appLogo} alt="app logo" width={110} height={29} className={classes.appLogo} />
          </Box>
        </Box>
        <Divider className={classes.divider} light />
        <Typography variant="body2" className={classes.description}>
          {description}
        </Typography>
        <Box display="flex" alignItems="center" paddingTop={2}>
          <img src={creatorLogo} alt="creator logo" width="65px" height="65px" />
          <Box display="flex" flexDirection="column" marginLeft={2}>
            <Typography variant="body2">
              <b>{isSingleCreator ? 'Creator' : 'Developed with'}</b>
            </Typography>
            <Typography variant="body2">{creatorInfo}</Typography>
          </Box>
        </Box>
      </CardContent>
      <CardActions disableSpacing className={classes.cardAction}>
        <Link
          underline="none"
          component="button"
          color="inherit"
          onClick={() => handleOnClick(app)}
        >
          <Box display="flex" alignItems="center">
            <Typography variant="subtitle2">{cardActionLabel}</Typography>
            <Box paddingRight={1} />
            <ArrowForwardIosRounded fontSize="inherit" />
          </Box>
        </Link>
      </CardActions>
    </Card>
  );
};

const useStyles = makeStyles({
  root: (props: ProgramCardProps) => ({
    backgroundColor: props.cardColor,
    padding: 8,
    marginRight: 16,
    marginBottom: 16,
    width: 350,
    minHeight: '320px',
    borderRadius: 15,
  }),
  appLogo: {
    marginRight: 1,
  },
  cardAction: {
    justifyContent: 'flex-end',
    paddingTop: 24,
    paddingRight: 16,
  },
  chip: {
    backgroundColor: 'white',
  },
  icon: {
    color: 'white',
  },
  divider: {
    backgroundColor: colors.gray,
    margin: 5,
  },
  description: {
    paddingTop: 12,
    paddingBottom: 15,
  },
});
